<template>
  <div class="faq">
    <h1 class="text-title-underline">{{ t('contact_faq.title') }}</h1>
    <template v-if="Array.isArray(faqCategories) && faqCategories.length">
      <div v-for="faqCategory in faqCategories" :key="faqCategory.id" class="mb-6">
        <div :id="`${faqCategory.id}`" class="pt-14 -mt-14">
          <h4 class="text-subtitle-underline">{{ faqCategory.name }}</h4>
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item v-for="faq in faqCategory.faqs" :key="faq.id" :name="faq.id">
              <template #title>
                <div class="flex items-center px-4 font-semibold">
                  <div class="text-mentalncText text-base">Q.</div>
                  <div class="px-2 text-gray-600">{{ faq.question }}</div>
                </div>
              </template>
              <div class="flex items-start px-4">
                <div class="font-semibold text-mentalncText text-base">A.</div>
                <div class="v-html whitespace-pre-wrap mt-0.5 mb-4 px-2" v-html="faq.answer" />
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </template>
    <template v-else>
      よくあるご質問が見つかりませんでした。
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { mdiAlphaQCircleOutline, mdiAlphaACircleOutline } from '@mdi/js'

export default defineComponent({
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const faqCategories = computed(() => store.state.contact.faqCategories)
    const activeName = ref(0)

    return {
      t,
      faqCategories,
      activeName,
      mdiAlphaQCircleOutline,
      mdiAlphaACircleOutline,
    }
  }
})
</script>

<style>
.faq .el-collapse-item__header {
  line-height: initial !important;
}
</style>
